<template>
    <div v-if="form">
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>เลขที่ใบจอง</label>
            </b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    v-model="form.order_id"
                    type="text"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>วันที่สร้างใบจอง</label></b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    v-model="form.created_at"
                    type="text"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11" v-if="form.customer">
            <b-col sm="4" class="col text-right"><label>เซลล์</label></b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    type="text"
                    v-model="form.customer.sale.name"
                    disabled>
            </b-col>
        </b-row>
        <br />
        <b-row sm="10" v-if="form.customer">
            <b-col sm="4" class="col text-right"
                ><label>รหัสลูกค้า</label></b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    v-model="form.customer.customer_id"
                    type="text"
                    disabled
            /></b-col>
        </b-row>
        <br />
        <template v-if="form.transport_type">
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>การขนส่ง</label>
                </b-col>
                <b-col sm="6">
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.transport_type.name"
                        disabled/></b-col>
            </b-row>
            <br />
        </template>
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>ค้างส่ง</label></b-col>
            <b-col sm="6">
                <input class="form-control" type="text"
                       v-model="form.remain_product"
                       disabled/>
            </b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="6"> <input class="form-control" type="hidden" /> </b-col>
        </b-row>
        <br />
        <div class="text-center">
            <b-form-group>
                <b-form-radio-group
                    v-model="form.order_status_id"
                    :options="OrderStatus"
                    name="radioInline">
                </b-form-radio-group>
            </b-form-group>
        </div>
        <br />
        <b-row>
            <div class="col text-center">
                <button
                    type="button"
                    class="btn btn-success"
                    @click="saveOrder">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="goToOrderList">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
<!--         <pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "order-modal",
    created() {
        this.$store.dispatch("Common/setOrderStatus");
    },
    data() {
        return {
            create_date: ""
        };
    },
    computed: {
        ...mapState({
            OrderStatus: state => {
                return [
                    ...state.Common.order_status.map(status => ({
                        value: status.id,
                        text: status.name
                    }))
                ];
            },
            form: state => {
                return state.Order.orderForm;
            }
        })
    },
    methods: {
        saveOrder() {
            this.$emit('submit',this.form);
        },
        goToOrderList() {
            this.$emit("submit", "cancel");
        }
    }
};
</script>

<style scoped></style>
